/**
 * @generated SignedSource<<d9d74b64f64cfd1a4bd986518cb99264>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WSEmployeeLeaveQuery$variables = {
  id: string;
};
export type WSEmployeeLeaveQuery$data = {
  readonly widgetEmployeeLeave: {
    readonly id: string;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly whitelistLeaveReasons: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type WSEmployeeLeaveQuery = {
  response: WSEmployeeLeaveQuery$data;
  variables: WSEmployeeLeaveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "WidgetEmployeeLeave",
    "kind": "LinkedField",
    "name": "widgetEmployeeLeave",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teams",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LeaveReason",
        "kind": "LinkedField",
        "name": "whitelistLeaveReasons",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSEmployeeLeaveQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSEmployeeLeaveQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "42365b5112ab9aeb87f50bce15822671",
    "id": null,
    "metadata": {},
    "name": "WSEmployeeLeaveQuery",
    "operationKind": "query",
    "text": "query WSEmployeeLeaveQuery(\n  $id: ID!\n) {\n  widgetEmployeeLeave(id: $id) {\n    id\n    teams {\n      id\n    }\n    whitelistLeaveReasons {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcf6525574b871c1d9100552537f137b";

export default node;
